import { DashboardWrapper } from "../../../container/dashboardWrapper"
import { Link } from 'react-router-dom';
import {
    Container,
    Heading,
    ContentWrapper,
    OverviewSection,
    Grid,
    AnnouncementContainer,
    AdminDashboardCountGrid,
    AdminDashboardCountGridItem
} from "../../../styles/dashboard";
import { Announcements } from "../../../components/dashboard-announcements";
import { ModuleHeader } from "../../../components/module-header";
import { AppUsageChart } from "../../../components/app-usage-chart";
import { UserChart } from "../../../components/user-chart";
import { AdminDashboardActivities } from "../../../components/admin-dashboard-activities";

const AdminDashboard = () => {
    return (
        <DashboardWrapper>
            <ContentWrapper>
                <Container>
                    <Heading>Welcome, Admin</Heading>
                    <OverviewSection>
                        <ModuleHeader title="overview" />
                        <AdminDashboardCountGrid>
                            <AdminDashboardCountGridItem active>
                                <span className="title">
                                    Student Count
                                </span>
                                <br />
                                <span className="count">
                                    3
                                </span>
                            </AdminDashboardCountGridItem>
                            <AdminDashboardCountGridItem>
                                <span className="title">
                                    Teacher Count
                                </span>
                                <br />
                                <span className="count">
                                    4
                                </span>
                            </AdminDashboardCountGridItem>
                            <AdminDashboardCountGridItem>
                                <span className="title">
                                    Total Users
                                </span>
                                <br />
                                <span className="count">
                                    7
                                </span>
                            </AdminDashboardCountGridItem>
                            <AdminDashboardCountGridItem>
                                <span className="title">
                                    Current Term
                                </span>
                                <br />
                                <span className="count">
                                    2ND
                                </span>
                            </AdminDashboardCountGridItem>
                        </AdminDashboardCountGrid>
                        <Grid>
                            <AppUsageChart />
                            <UserChart />
                        </Grid>
                    </OverviewSection>
                    <AnnouncementContainer>
                        <ModuleHeader title="ACTIVITIES" />
                        <AdminDashboardActivities scroll />
                    </AnnouncementContainer>
                </Container>
            </ContentWrapper>
        </DashboardWrapper>
    )
}

export default AdminDashboard
